import { render, staticRenderFns } from "./CalendarioHistoricoPantalla.vue?vue&type=template&id=81d03734&"
import script from "./CalendarioHistoricoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CalendarioHistoricoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports